module.exports = (window.Handlebars["default"] || window.Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"text-center\">\n	<span class=\"fas fa-phone\"></span>\n	"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.formattedNumber : depth0), depth0))
    + "\n</div>";
},"useData":true})